// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_jr-0";